"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeserializationPath = void 0;
class DeserializationPath {
    constructor(path) {
        this.path = path;
    }
    append(path) {
        return new DeserializationPath((this.path || []).concat(path));
    }
    toString() {
        var _a;
        return ((_a = this.path) === null || _a === void 0 ? void 0 : _a.join('.')) || '';
    }
}
exports.DeserializationPath = DeserializationPath;
